import { ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";

export async function download(path) {
    const res = await api.get(path, { responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "export";
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return name;
}

export const num = (v, digits = 1) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: digits }));

export const DataTable = ({ caption, columns, rows, testId, onRowClick, sort, onSort, empty = "Nessun dato" }) => (
    <div className="overflow-x-auto edi-card" data-testid={testId} tabIndex={0} role="region" aria-label={caption}>
        <table className="w-full text-left text-sm">
            <caption className="text-left font-heading font-bold text-base px-4 pt-4 pb-2">{caption}</caption>
            <thead>
                <tr className="border-b-2 border-edi-border-strong">
                    {columns.map((c) => (
                        <th key={c.key} scope="col" className="px-4 py-2 whitespace-nowrap" aria-sort={sort?.key === c.key ? (sort.dir === "asc" ? "ascending" : "descending") : undefined}>
                            {onSort && c.sortable !== false ? (
                                <button type="button" className="font-bold underline-offset-2 hover:underline" onClick={() => onSort(c.key)} data-testid={`${testId}-sort-${c.key}`}>
                                    <span className="inline-flex items-center gap-1">{c.label}{sort?.key === c.key && (sort.dir === "asc" ? <ChevronUp aria-hidden="true" size={14} /> : <ChevronDown aria-hidden="true" size={14} />)}</span>
                                </button>
                            ) : c.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.length === 0 && <tr><td colSpan={columns.length} className="px-4 py-4" data-testid={`${testId}-empty`}>{empty}</td></tr>}
                {rows.map((r, i) => (
                    <tr key={r.id || r.key || r.label || i} className="border-b border-edi-border align-top" data-testid={`${testId}-row-${i}`}>
                        {columns.map((c, ci) => (
                            <td key={c.key} className="px-4 py-2">
                                {ci === 0 && onRowClick ? (
                                    <button type="button" className="text-left font-semibold text-edi-link underline" onClick={() => onRowClick(r)} data-testid={`${testId}-open-${i}`}>
                                        {c.render ? c.render(r) : r[c.key]}
                                    </button>
                                ) : c.render ? c.render(r) : r[c.key] ?? "—"}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export const Bar = ({ value }) => (
    <div className="h-2.5 w-28 sm:w-40 rounded-md bg-edi-track overflow-hidden" aria-hidden="true">
        <div className="h-full bg-edi-lime" style={{ width: `${Math.min(100, value || 0)}%` }} />
    </div>
);
